export default "__VITE_ASSET__CyEbMLhr__";